//@constants
const actionTypes = require('constants/actionTypes');
const { FIRST_STEP } = require('constants/index');
const { CREDIT_CARD_REVOLVING_PROCESS } = require('constants/flagBasedFeatures');
//@utilities
const { APIPost } = require('utilities/APIRequestHelper');
//@actions
const signaturePatternActions = require('actions/signaturePattern');
const { setTermsAndCondsInfoRevolving } = require('actions/cardRevolvingDocuments');
const { formatText } = require('core/i18n').i18n;
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

const requestDecreaseLimitInProgress = () => {
    return {
        type: actionTypes.CARD_MODIFY_LIMIT_DECREASE_REQUEST
    };
};

const requestDecreaseLimitSuccess = (approvedAmount) => {
    return {
        type: actionTypes.CARD_MODIFY_LIMIT_DECREASE_SUCCESS,
        payload: {
            approvedAmount
        }
    };
};

const requestDecreaseLimitFailure = error => {
    return {
        type: actionTypes.CARD_MODIFY_LIMIT_DECREASE_FAILURE,
        payload: {
            error
        }
    };
};

const requestDecreaseLimit = (cardId, amount, creditLimit, documentId) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immCard = getState().cards.getIn(['byId', cardId]);
        const productSubType = immCard.getIn(['product', 'subtype'])
        const immCardModifyLimit = getState().cardModifyNewLimit;
        const immCardChangeNewPaymentMethod = getState().cardChangeNewPaymentMethod;
        const currentLimitCode = immCard.get('currentLimitCode');
        const immStepOne = immCardModifyLimit.getIn(['steps', FIRST_STEP]);
        const contractNumberAccount = immCard.getIn(['contract', 'number']);
        const showIneAndRevolving = getState().flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
        const operationProcessIdInitPolicy = immCardChangeNewPaymentMethod.get('operationProcessIdInitPolicy')
        const currency = immCard.getIn(['limit', 'currency'])
        const contractNumber = immCard.get('fullContractNumber')
        const params = {
            header: {
                version: 2,
            },
            query: {
                codigoLimiteActual: currentLimitCode,
                codigoSubtipoProducto: productSubType,
                contractNumber,
                contrato: {
                    numerodecontrato: contractNumberAccount,
                    producto: immCard.getIn(['contract', 'product'])
                },
                dataToken,
                limiteImporteActual: {
                    divisa: currency,
                    importe: amount || immStepOne.get('currentLimit')
                },
                nuevoLimite: {
                    divisa: currency,
                    importe: creditLimit || immStepOne.get('tentativeLimit')
                },
                pan: immCard.get('number'),
                operationProcessId: operationProcessIdInitPolicy,
                acceptanceText: formatText('hireCardOpenCreditStepINE-titlePdf'),
                scrollDown: false,
                documentId
            }
        };

        dispatch(requestDecreaseLimitInProgress());
        return APIPost({ dispatch, endpoint: 'cardDecreaseLimit', params })

            .then(() => {
                if (showIneAndRevolving) {
                    const termsAndsCondsHiringData = [
                        {
                            standard: immCard.getIn(['product', 'standard']),
                            subType: immCard.getIn(['product', 'subtype']),
                            type: immCard.getIn(['product', 'type'])
                        }
                    ];
                    dispatch(setTermsAndCondsInfoRevolving(immCard.get('standarAlias'), termsAndsCondsHiringData, contractNumber));
                }
                dispatch(requestDecreaseLimitSuccess(immStepOne.get('tentativeLimit')))
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(requestDecreaseLimitFailure(response));
                } else {
                    throw response;
                }
            });
    };

    new Promise(() => signaturePatternActions.validateAndExecute(dispatch, getState, callback));
};

module.exports = { requestDecreaseLimit };
